import React from "react";
import { motion } from "framer-motion";
import { CheckCheckIcon, Trash2, Loader2 } from "lucide-react";
import { FaTable } from "react-icons/fa";
import { HiViewGrid } from "react-icons/hi";
import { arClass } from "../../../utils/useArClass";

const WaitingRoomControls = ({
  statusButtons,
  filters,
  setFilters,
  handleSelectAll,
  selectedIds,
  deleteSelectedRequest,
  handleDeleteAll,
  darkMode,
  Text,
  viewMode,
  onViewModeChange,
  defaultLanguage,
}) => {
  const toggleClass = (active) =>
    `p-3 transition-colors max-sm:p-2 ${
      active
        ? "bg-blue-600 !text-white"
        : darkMode
          ? "!bg-gray-700 !text-gray-300 hover:!bg-gray-600"
          : "!bg-gray-100 !text-gray-600 hover:!bg-gray-200"
    }`;

  return (
    <div className={arClass("flex items-start gap-3 mt-4 w-full justify-between flex-col ")}>
      <div className={arClass("grid grid-cols-2 sm:grid-cols-3 2xl:grid-cols-6  gap-2  w-full")}>
        {statusButtons.map((b) => (
          <motion.button
            key={b.key}
            onClick={() => setFilters((prev) => ({ ...prev, status: b.key }))}
            className={arClass(
              `px-3 py-2 rounded-lg text-sm font-semibold border transition max-sm:text-xs col-span-1 text-center ${
                filters.status === b.key
                  ? "bg-medical-100 text-medical-700 ring-1 ring-medical-200"
                  : darkMode
                  ? "bg-slate-800 text-slate-300 border-slate-700 hover:bg-slate-700"
                  : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
              }`,
            )}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Text>{b.labelKey}</Text>
          </motion.button>
        ))}
      </div>
      <div className={arClass("flex items-center gap-2   w-full justify-end max-sm:w-full")}>
        <div className={arClass("flex rounded-lg border overflow-hidden")}>
          <button
            onClick={() => onViewModeChange("table")}
            className={arClass(
              `${toggleClass(viewMode === "table")} ${
                defaultLanguage === "ar" ? "rounded-r-lg" : "rounded-l-lg"
              }`,
            )}
            title="Table view"
          >
            <FaTable size={20} />
          </button>
          <button
            onClick={() => onViewModeChange("grid")}
            className={arClass(
              `${toggleClass(viewMode === "grid")} ${
                defaultLanguage === "ar" ? "rounded-l-lg" : "rounded-r-lg"
              }`,
            )}
            title="Grid view"
          >
            <HiViewGrid size={20} />
          </button>
        </div>
        <motion.button
          onClick={handleSelectAll}
          className={arClass(
            `flex items-center justify-between gap-2 px-4 py-2 rounded-lg text-sm font-semibold border transition max-sm:text-xs w-max max-sm:flex-1 ${
              darkMode
                ? "!bg-blue-800 !text-blue-300 !border-blue-700 hover:bg-blue-700"
                : "!bg-white !text-blue-600 !border-blue-200 hover:bg-blue-50"
            }`,
          )}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={deleteSelectedRequest}
        >
          <span className={arClass("flex items-center gap-1")}>
            <CheckCheckIcon />
            <Text>selectAll</Text>
          </span>
          {selectedIds.length > 0 && (
            <span
              className={arClass(
                "ml-2 inline-flex items-center justify-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800",
              )}
            >
              {selectedIds.length}
            </span>
          )}
        </motion.button>
        <motion.button
          onClick={handleDeleteAll}
          className={arClass(
            `inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold border transition max-sm:text-xs w-max max-sm:flex-1 ${
              darkMode
                ? "!bg-red-800 !text-red-300 !border-red-700 hover:bg-red-700"
                : "!bg-white !text-red-600 !border-red-200 hover:bg-red-50"
            }`,
          )}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={selectedIds.length === 0 || deleteSelectedRequest}
        >
          {deleteSelectedRequest ? (
            <>
              <Loader2 className="animate-spin" size={16} />
              <Text>deleting...</Text>
            </>
          ) : (
            <>
              <Trash2 />
              <Text>deleteSelectedEntries</Text>
            </>
          )}
        </motion.button>
      </div>
    </div>
  );
};

export default WaitingRoomControls;
